// Generated by purs version 0.14.3
"use strict";
var $foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object/ST.js");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var peek = $foreign.peekImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
module.exports = {
    peek: peek,
    "new": $foreign["new"],
    poke: $foreign.poke,
    "delete": $foreign["delete"]
};

